// extracted by mini-css-extract-plugin
export default {"body":"PassCheckoutModal_body__xFynj","shirt":"PassCheckoutModal_shirt__1iAQ6","note":"PassCheckoutModal_note__UE0JP"};